import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { DatePicker } from "antd";
import ReactTable from "react-table";
import SimpleReactValidator from "simple-react-validator";
import Spinner from "components/common/Spinner";
import { findItemValueByIdFromArray } from "functions/find-item-by-id-from-array";
import SearchSelect from "components/common/SearchSelect";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import {
    getJobs,
    getJobProducts,
    getReportLayoutById,
    insertReportLayout,
    updateReportLayout
} from "api/menu/master-files/report-builder/actions";
import {
    getQuestionByIdWithCallback
} from "api/menu/master-files/question-library/actions";

import UserTypes from "components/auth/user-types";

const AddHeader = React.lazy(() =>
    import("components/menu/master-files/report-builder/add-header"));
const CreateHeaderModal = React.lazy(() =>
    import("components/menu/master-files/question-library/create-header-modal"));
const AddQuestion = React.lazy(() =>
    import("components/menu/master-files/report-builder/add-question"));
const CreateQuestionModal = React.lazy(() =>
    import("components/menu/master-files/question-library/create-question-modal"));

class EditReportLayout extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            jobOptions: this.props.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            })),
            productOptions: this.createProductOptions(this.props),
            singleReportLayout: this.props.reportId && this.props.singleReportLayout
                ? this.props.singleReportLayout
                : {
                    jobId: null,
                    productId: 0,
                    jobProductId: null,
                    description: "",
                    clientCommentsLabel: null,
                    serviceFromDate: moment()                        .format(this.dateFormat),
                    serviceToDate: moment()                        .format(this.dateFormat),
                    matchDateRange: false,
                    photosRequired: false,
                    signoffRequired: false,
                    deficiencyFormRequired: false,
                    releaseRequired: false,
                    displayCompletionChartToClient: false,
                    inactive: false,
                    details: []
                }
        };

        this.setLoading = this.setLoading.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.handleFlagged = this.handleFlagged.bind(this);
        this.moveUp = this.moveUp.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.handleAddHeader = this.handleAddHeader.bind(this);
        this.handleCreateHeader = this.handleCreateHeader.bind(this);
        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleCreateQuestion = this.handleCreateQuestion.bind(this);
        this.handleChangeSummaryHeader = this.handleChangeSummaryHeader.bind(this);

        this.props.getJobs();
        if (this.props.reportId) {
            this.props.getReportLayoutById(this.props.reportId);
        }

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    componentWillReceiveProps(nextProps) {
        const newStates = {};
        if (!_.isEqual(nextProps.jobs, this.props.jobs)) {
            newStates.jobOptions = nextProps.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            }));
        }
        if (!_.isEqual(nextProps.jobProducts, this.props.jobProducts)) {
            newStates.productOptions = this.createProductOptions(nextProps);
        }
        if (!_.isEqual(nextProps.singleReportLayout, this.props.singleReportLayout)) {
            newStates.singleReportLayout = nextProps.singleReportLayout;
            this.props.getJobProducts(newStates.singleReportLayout.jobId);
        }

        if (Object.keys(newStates).length) {
            this.setState(newStates);
        }
    }

    setLoading = (status) => {
        this.setState({
            loading: status
        });
    };
    createProductOptions = (props) => props.jobProducts.map(value => ({
        label: value.product,
        value: value.id,
        productId: value.productId
    }));

    handleSelect = (name, option) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        singleReportLayout[name] = option ? option.value : null;
        if (name === "jobProductId") {
            singleReportLayout.productId = option.productId;
        }
        this.setState({ singleReportLayout });
        if (name === "jobId") {
            this.props.getJobProducts(option.value);
        }
    };

    handleInput = (name, value) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        singleReportLayout[name] = value;
        this.setState({ singleReportLayout });
    };

    handleChangeDate = (name, date) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        singleReportLayout[name] = date ? date.format(this.dateFormat) : null;
        this.setState({ singleReportLayout });
    };

    handleSave = (asNew = false) => {
        if (this.validator.allValid()) {
            this.setLoading(true);
            const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
            singleReportLayout.details = singleReportLayout.details.map(item => {
                // eslint-disable-next-line no-restricted-globals
                if (isNaN(parseInt(item.detailId, 10))) {
                    delete item.detailId;
                }
                return item;
            });
            if (asNew) {
                this.props.insertReportLayout(
                    singleReportLayout,
                    this.props.onCancel
                );
            } else {
                this.props.updateReportLayout(
                    this.props.reportId,
                    singleReportLayout,
                    this.props.onCancel
                );
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleCheckbox = (detailId, name) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        const details = Object.assign([], singleReportLayout.details);
        const itemIndex = details.findIndex(item => item.detailId === detailId);
        if (itemIndex < 0) {
            return;
        }
        details[itemIndex][name] = !details[itemIndex][name];
        singleReportLayout.details = details;
        this.setState({
            singleReportLayout
        });
    };

    handleFlagged = (detailId, option) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        const details = Object.assign([], singleReportLayout.details);
        const itemIndex = details.findIndex(item => item.detailId === detailId);
        if (itemIndex < 0) {
            return;
        }
        details[itemIndex].flaggedItems = option
            ? option.map(item => item.value)
            : [];
        singleReportLayout.details = details;
        this.setState({ singleReportLayout });
    };

    handleChangeSummaryHeader = (detailId, value) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        const details = Object.assign([], singleReportLayout.details);
        const itemIndex = details.findIndex(item => item.detailId === detailId);
        if (itemIndex < 0) {
            return;
        }
        details[itemIndex].summaryHeading = value;
        singleReportLayout.details = details;
        this.setState({
            singleReportLayout
        });
    }

    moveUp = (up, detailId) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        const details = Object.assign([], singleReportLayout.details);
        const itemIndex = details.findIndex(item => item.detailId === detailId);
        if (itemIndex < 0 || itemIndex > details.length - 1) {
            return;
        }
        const itemChangeWithIndex = up ? itemIndex - 1 : itemIndex + 1;
        const currentItemDisplaySequence = details[itemChangeWithIndex].displaySequence;
        details[itemChangeWithIndex].displaySequence = details[itemIndex].displaySequence;
        details[itemIndex].displaySequence = currentItemDisplaySequence;

        singleReportLayout.details = details;
        this.setState({ singleReportLayout });
    };

    removeItem = (detailId) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        const itemIndex = singleReportLayout.details.findIndex(item => item.detailId === detailId);
        if (itemIndex < 0) {
            return;
        }
        singleReportLayout.details.splice(itemIndex, 1);
        singleReportLayout.details.forEach((value, index) => {
            singleReportLayout.details[index].displaySequence = index + 1;
        });
        this.setState({ singleReportLayout });
    };

    addItem = (isHeader, item) => {
        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
        singleReportLayout.details = Object.assign([], singleReportLayout.details);
        const displaySequenceArray = singleReportLayout.details
            .map(detail => detail.displaySequence);
        const displaySequence = (displaySequenceArray.length
            ? _.max(displaySequenceArray)
            : 0) + 1;
        const index = singleReportLayout.details.push({
            isHeader,
            questionId: item.id,
            answers: item.answers && Array.isArray(item.answers) ? item.answers : [],
            questionText: item.text,
            detailId: `new-${_.random(0, 10000000)}`,
            displaySequence,
            allowComments: false,
            onClientSummary: false,
            flaggedItems: [],
            summaryHeading: null
        }) - 1;

        this.setState({
            singleReportLayout
        }, () => {
            const tBody = document.getElementsByClassName("report-builder-edit-modal");
            if (tBody && tBody[0]) {
                tBody[0].scrollTop = tBody[0].scrollHeight;
            }

            if (!isHeader) {
                this.props.getQuestionByIdWithCallback(item.id, response => {
                    if (response && response.answers && Array.isArray(response.answers)) {
                        const singleReportLayout = Object.assign({}, this.state.singleReportLayout);
                        singleReportLayout.details = Object.assign([], singleReportLayout.details);
                        singleReportLayout.details[index].answers = response.answers;
                        singleReportLayout.details[index].summaryHeading = response.text;
                        this.setState({
                            singleReportLayout
                        });
                    }
                });
            }
        });
    };

    handleAddHeader = (jobId) => {
        const modalObj = {
            id: "add-header",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                },
            },
            header: "Add Header",
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <AddHeader
                        jobId={jobId || false}
                        onAdd={item => {
                            this.addItem(true, item);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleCreateHeader = () => {
        const { singleReportLayout } = this.state;
        const modalObj = {
            id: "create-edit-header",
            modalSettings: {
                size: "sm",
            },
            header: "Create Header",
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <CreateHeaderModal
                        onSave={(newHeader) => {
                            this.addItem(true, {
                                id: newHeader.id,
                                answers: newHeader.answers && Array.isArray(newHeader.answers)
                                    ? newHeader.answers.filter(item => item !== null)
                                    : [],
                                text: newHeader.text,
                            });
                            this.props.closeCustomModal(modalObj);
                        }}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        jobId={singleReportLayout && singleReportLayout.jobId
                            ? singleReportLayout.jobId
                            : false}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleAddQuestion = () => {
        const modalObj = {
            id: "add-question",
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                },
            },
            header: "Add Question",
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <AddQuestion
                        onAdd={item => {
                            this.addItem(false, item);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleCreateQuestion = () => {
        const modalObj = {
            id: "create-edit-question",
            modalSettings: {
                size: "sm",
            },
            header: "Create Question",
            children: (
                <React.Suspense
                    fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <CreateQuestionModal
                        onSave={(newQuestion) => {
                            this.addItem(false, {
                                id: newQuestion.id,
                                answers: newQuestion.answers && newQuestion.answers.length
                                    ? newQuestion.answers
                                    : [],
                                text: newQuestion.text,
                            });
                            this.props.closeCustomModal(modalObj);
                        }}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        questionId={false}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            onCancel,
            reportId
        } = this.props;
        const {
            singleReportLayout,

            jobOptions,
            productOptions,
        } = this.state;

        const currentJob = findItemValueByIdFromArray(
            jobOptions,
            "value",
            singleReportLayout.jobId
        ) || null;

        const currentProduct = findItemValueByIdFromArray(
            productOptions,
            "value",
            singleReportLayout.jobProductId
        ) || null;
        const tableData = (singleReportLayout.details || []).sort((item1, item2) => {
            if (item1.displaySequence > item2.displaySequence) {
                return 1;
            } else if (item1.displaySequence < item2.displaySequence) {
                return -1;
            }
            return 0;
        });

        return (
            <div className="dashboard">
                <div className="row pt-1 pb-3">
                    <div className="col-2">
                        <div className="form-group ">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Job
                            </label>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                isSearchable={true}
                                options={jobOptions}
                                value={currentJob}
                                onChange={(option) => this.handleSelect("jobId", option)}
                            />
                            {this.validator.message("jobId", currentJob ? currentJob.value : null, "required")}
                        </div>
                        <div className="form-group ">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Product
                            </label>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                isSearchable={true}
                                options={productOptions}
                                value={currentProduct}
                                onChange={(option) => this.handleSelect("jobProductId", option)}
                            />
                            {this.validator.message("jobProductId", currentProduct ? currentProduct.value : null, "required")}
                        </div>
                        <div className="form-group ">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Description
                            </label>
                            <input
                                type="text"
                                name="description"
                                value={singleReportLayout.description || ""}
                                onChange={(ev) => this.handleInput("description", ev.target.value)}
                                className="form-control"
                            />
                            {this.validator.message("description", singleReportLayout.description, "required")}
                        </div>
                    </div>

                    <div className="col-3">
                        <fieldset className="border p-2">
                            <legend className="w-auto mb-0">
                                <small>Applicable To Services Between</small>
                            </legend>

                            <div className="form-group mb-2">
                                <label className="d-block mb-0 font-weight-bold form-label">
                                    From Date
                                </label>
                                <DatePicker
                                    value={moment(singleReportLayout.serviceFromDate) || null}
                                    format={this.dateFormat}
                                    onChange={date => this.handleChangeDate("serviceFromDate", date)}
                                    className="d-block"
                                />
                                {this.validator.message("serviceFromDate", singleReportLayout.serviceFromDate, "required")}
                            </div>
                            <div className="form-group mb-2">
                                <label className="d-block mb-0 font-weight-bold form-label">
                                    To Date
                                </label>
                                <DatePicker
                                    value={moment(singleReportLayout.serviceToDate) || null}
                                    format={this.dateFormat}
                                    onChange={date => this.handleChangeDate("serviceToDate", date)}
                                    className="d-block"
                                />
                                {this.validator.message("serviceToDate", singleReportLayout.serviceToDate, "required")}
                            </div>
                            <div className="custom-control custom-checkbox">
                                <input
                                    id="matchDateRange"
                                    type="checkbox"
                                    checked={!!singleReportLayout.matchDateRange}
                                    className="custom-control-input"
                                    onChange={() => this.handleInput("matchDateRange", !singleReportLayout.matchDateRange)}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor="matchDateRange"
                                >
                                    Service Must Match Dates
                                </label>
                            </div>
                        </fieldset>
                    </div>

                    <div className="col-3">
                        <fieldset className="border p-2">
                            <legend className="w-auto mb-0">
                                <small>Required Uploads</small>
                            </legend>

                            <div className="custom-control custom-checkbox mb-2">
                                <input
                                    id="photosRequired"
                                    type="checkbox"
                                    checked={!!singleReportLayout.photosRequired}
                                    className="custom-control-input"
                                    onChange={() => this.handleInput("photosRequired", !singleReportLayout.photosRequired)}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor="photosRequired"
                                >
                                    One Or More Photos
                                </label>
                            </div>

                            <div className="custom-control custom-checkbox mb-2">
                                <input
                                    id="signoffRequired"
                                    type="checkbox"
                                    checked={!!singleReportLayout.signoffRequired}
                                    className="custom-control-input"
                                    onChange={() => this.handleInput("signoffRequired", !singleReportLayout.signoffRequired)}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor="signoffRequired"
                                >
                                    Signoff Sheet/Order Form
                                </label>
                            </div>

                            <div className="custom-control custom-checkbox mb-2">
                                <input
                                    id="deficiencyFormRequired"
                                    type="checkbox"
                                    checked={!!singleReportLayout.deficiencyFormRequired}
                                    className="custom-control-input"
                                    onChange={() => this.handleInput("deficiencyFormRequired", !singleReportLayout.deficiencyFormRequired)}
                                />
                                <label
                                    className="custom-control-label"
                                    htmlFor="deficiencyFormRequired"
                                >
                                    Deficiency Form
                                </label>
                            </div>
                        </fieldset>
                    </div>

                    <div className="col-2">
                        <div className="form-group">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                Client Comments Label
                            </label>
                            <input
                                type="text"
                                name="clientCommentsLabel"
                                value={singleReportLayout.clientCommentsLabel || ""}
                                onChange={(ev) => this.handleInput("clientCommentsLabel", ev.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="custom-control custom-checkbox mb-2">
                            <input
                                id="releaseRequired"
                                type="checkbox"
                                checked={!singleReportLayout.releaseRequired}
                                className="custom-control-input"
                                onChange={() => this.handleInput("releaseRequired", !singleReportLayout.releaseRequired)}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="releaseRequired"
                            >
                                Release To Client Required
                            </label>
                        </div>
                        <div className="custom-control custom-checkbox mb-2">
                            <input
                                id="inactive"
                                type="checkbox"
                                checked={!!singleReportLayout.inactive}
                                className="custom-control-input"
                                onChange={() => this.handleInput("inactive", !singleReportLayout.inactive)}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="inactive"
                            >
                                Inactive
                            </label>
                        </div>
                    </div>

                    <div className="col-2 d-flex flex-column pt-3">
                        {reportId ?
                            <button
                                className="btn btn-success mb-2 mt-2"
                                onClick={() => this.handleSave(false)}
                            >
                                Save
                            </button>
                            : null}
                        <button
                            className="btn btn-primary mb-2 mt-2"
                            onClick={() => this.handleSave(true)}
                        >
                            Save As New
                        </button>
                        <button
                            className="btn btn-outline-danger mb-2 mt-2"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                <div className="d-flex mb-3">
                    <div className="mr-5">
                        <button
                            className="btn btn-outline-primary mr-3"
                            onClick={() => this.handleAddHeader(singleReportLayout.jobId)}
                        >
                            Add header
                        </button>
                        <button
                            className="btn btn-outline-primary"
                            onClick={() => this.handleCreateHeader()}
                        >
                            Create New Header
                        </button>
                    </div>
                    <div className="ml-5">
                        <button
                            className="btn btn-outline-info mr-3"
                            onClick={this.handleAddQuestion}
                        >
                            Add Question
                        </button>
                        {
                            this.props.role.includes(UserTypes.admin) ?
                                <button
                                    className="btn btn-outline-info"
                                    onClick={() => this.handleCreateQuestion()}
                                >
                                    Create New Question
                                </button> : null
                        }
                    </div>
                </div>
                {!this.state.loading || <Spinner />}
                <ReactTable
                    data={tableData}
                    columns={[
                        {
                            id: "questionId",
                            Header: "QID",
                            accessor: "questionId",
                            width: 60
                        },
                        {
                            id: "questionText",
                            Header: "Question",
                            accessor: "questionText",
                            Cell: ({ original }) => (
                                typeof original.questionText === "string"
                                    ? original.questionText.split("\n")
                                        .map((item, key) =>
                                            <React.Fragment key={key}>
                                                {item}<br/>
                                            </React.Fragment>)
                                    : original.questionText
                            ),
                            style: {
                                whiteSpace: "unset"
                            }
                        },
                        {
                            id: "summaryHeading",
                            Header: "Summary Header",
                            accessor: "summaryHeading",
                            style: {
                                whiteSpace: "unset"
                            },
                            Cell: ({ original }) => (
                                !original.isHeader ? <input
                                    type="text"
                                    defaultValue={original.summaryHeading}
                                    onBlur={(e) =>
                                        this.handleChangeSummaryHeader(original.detailId,
                                            e.target.value)}
                                    className="form-control"
                                /> : original.questionText
                            ),
                        },
                        {
                            id: "onClientSummary",
                            Header: "On Client Summary",
                            accessor: "onClientSummary",
                            width: 115,
                            Cell: ({ original }) => (
                                <input
                                    type="checkbox"
                                    checked={original.onClientSummary}
                                    onChange={() => this.handleCheckbox(original.detailId, "onClientSummary")}
                                    className="form-control"
                                />
                            ),
                        },
                        {
                            id: "allowComments",
                            Header: "Allow Comments",
                            accessor: "allowComments",
                            width: 115,
                            Cell: ({ original }) => (
                                original.isHeader || (
                                    <input
                                        type="checkbox"
                                        checked={original.allowComments}
                                        onChange={() => this.handleCheckbox(original.detailId, "allowComments")}
                                        className="form-control"
                                    />
                                )
                            ),
                        },
                        {
                            id: "flagged-answers",
                            Header: "Flagged Answers",
                            accessor: "flaggedAnswers",
                            style: {
                                overflow: "unset"
                            },
                            Cell: ({ original }) => {
                                if (original.isHeader) {
                                    return null;
                                }
                                const options = original.answers && Array.isArray(original.answers)
                                    ? original.answers
                                        .filter(item => item !== null)
                                        .map(answer => ({
                                            label: answer.answerText,
                                            value: answer.answerId,
                                        }))
                                    : [];
                                const selectedValues = options.filter(option =>
                                    original.flaggedItems.indexOf(option.value) > -1);
                                return (
                                    <div>
                                        <SearchSelect
                                            className="custom-react-select"
                                            isLoading={false}
                                            isClearable={true}
                                            isSearchable={true}
                                            isMulti={true}
                                            options={options}
                                            value={selectedValues}
                                            onChange={(option) =>
                                                this.handleFlagged(original.detailId, option)}
                                        />
                                    </div>
                                );
                            },
                        },
                        {
                            id: "actions",
                            Header: "Actions",
                            width: 120,
                            Cell: ({
                                       original,
                                       index
                                   }) => (
                                <div className="d-flex justify-content-around">
                                    <div className="btn-group">
                                        <button
                                            className={`btn btn-sm ${original.isHeader ? "btn-outline-light" : "btn-outline-primary"}`}
                                            onClick={() => this.moveUp(true, original.detailId)}
                                            disabled={index === 0}
                                        >
                                            <FontAwesomeIcon icon="arrow-up"/>
                                        </button>
                                        <button
                                            className={`btn btn-sm ${original.isHeader ? "btn-outline-light" : "btn-outline-primary"}`}
                                            onClick={() => this.moveUp(false, original.detailId)}
                                            disabled={index === tableData.length - 1}
                                        >
                                            <FontAwesomeIcon icon="arrow-down"/>
                                        </button>
                                    </div>
                                    <button
                                        className={`btn btn-sm ${original.isHeader ? "btn-danger" : "btn-outline-danger"}`}
                                        onClick={() => this.removeItem(original.detailId)}
                                    >
                                        <FontAwesomeIcon icon="trash-alt"/>
                                    </button>
                                </div>
                            ),
                        },
                    ]}
                    headerClassName="table-header"
                    getTbodyProps={() => ({
                        className: "report-builder-edit-modal"
                    })}
                    showPagination={false}
                    pageSize={Math.max(20, tableData.length)}
                    resizable
                    className="-striped -highlight"
                    loading={false}
                    defaultFilterMethod={filterCaseInsensitive}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            if (rowInfo.original && rowInfo.original.isHeader) {
                                return {
                                    className: "bg-info text-light"
                                };
                            }
                        }
                        return {};
                    }}
                    style={{
                        height: "calc(100vh - 350px)",
                    }}
                />
            </div>
        );
    }
}

EditReportLayout.propTypes = {
    reportId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    onCancel: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    role: state.auth.user.role,
    jobs: state.reportBuilder.jobs,
    jobProducts: state.reportBuilder.jobProducts,
    singleReportLayout: state.reportBuilder.singleReportLayout,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getJobs: bindActionCreators(getJobs, dispatch),
    getJobProducts: bindActionCreators(getJobProducts, dispatch),
    getReportLayoutById: bindActionCreators(getReportLayoutById, dispatch),

    insertReportLayout: bindActionCreators(insertReportLayout, dispatch),
    updateReportLayout: bindActionCreators(updateReportLayout, dispatch),

    getQuestionByIdWithCallback: bindActionCreators(getQuestionByIdWithCallback, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(EditReportLayout);
